import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="alpilles-topo-bg text-white mt-24">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_craft-beer-shop-1/artifacts/5xgb6py8_LOGO%20SEUL.png"
                alt="Soif de Provence Logo"
                className="h-8 w-8 object-contain brightness-0 invert"
              />
              <h3 className="text-2xl font-heading">Soif de Provence</h3>
            </div>
            <p className="text-white/80">
              Brasserie artisanale<br />
              Saint-Rémy-de-Provence<br />
              au cœur des Alpilles
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/nos-bieres" className="hover:text-white transition-colors">Nos bières</Link></li>
              <li><Link to="/professionnels" className="hover:text-white transition-colors">Professionnels</Link></li>
              <li><Link to="/points-de-vente" className="hover:text-white transition-colors">Points de vente</Link></li>
              <li><Link to="/location-tireuse" className="hover:text-white transition-colors">Location de tireuse</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Nous contacter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <div className="text-white/80 space-y-2">
              <p className="font-medium">Denis BONNELY</p>
              <p>
                1688 petite route des Jardins<br />
                13210 Saint-Rémy-de-Provence<br />
                France
              </p>
              <p>
                <a
                  href="https://maps.google.com/?q=1688+petite+route+des+Jardins,+13210+Saint-Rémy-de-Provence,+France"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent hover:text-accent/80 transition-colors inline-flex items-center gap-1"
                >
                  Voir sur Google Maps
                </a>
              </p>
              <p>Tél: <a href="tel:+33664822759" className="hover:text-white transition-colors">06 64 82 27 59</a></p>
              <p>Email: <a href="mailto:soifdeprovence@gmail.com" className="hover:text-white transition-colors">soifdeprovence@gmail.com</a></p>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Légal</h4>
            <ul className="space-y-2 text-white/80">
              <li><Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link></li>
              <li><Link to="/confidentialite" className="hover:text-white transition-colors">Confidentialité</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 text-center text-white/60">
          <p>© 2025 Soif de Provence. Tous droits réservés. L'abus d'alcool est dangereux pour la santé.</p>
        </div>
      </div>
    </footer>
  );
}
